import React from 'react';
import Modal from '../../components/Modal';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** تأیید عملیات حساس (حذف و …) به‌جای window.confirm */
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, message, confirmLabel = 'تأیید', danger = false, busy = false, onConfirm, onClose }) => (
  <Modal isOpen={open} onClose={() => !busy && onClose()} title={title} size="small">
    <div className="space-y-5">
      <div className="text-sm leading-7 text-gray-700">{message}</div>
      <div className="flex justify-end gap-2">
        <button type="button" onClick={onClose} disabled={busy} className="rounded-xl border border-gray-200 px-4 py-2 text-sm font-bold text-gray-700 hover:bg-gray-50">
          انصراف
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={busy}
          className={`rounded-xl px-4 py-2 text-sm font-bold text-white disabled:opacity-60 ${danger ? 'bg-red-600 hover:bg-red-700' : 'bg-[#4a2e68] hover:bg-[#392352]'}`}
        >
          {busy ? 'در حال انجام…' : confirmLabel}
        </button>
      </div>
    </div>
  </Modal>
);

export default ConfirmDialog;
